import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Button } from '@material-ui/core';
import { translations } from '../../../../locales/translations';
import { useTranslation } from 'react-i18next';
import { useContractDataSlice } from '../slice';
import { useDispatch, useSelector } from 'react-redux';
import { selectPreviewMode } from '../slice/selectors';

export const PreviewButton = (props) => {
  const { resetPreview, setResetPreview } = props;
  const { t } = useTranslation();
  const previewMode = useSelector(selectPreviewMode);
  const { actions } = useContractDataSlice();
  const dispatch = useDispatch();
  const [displayWording, setDisplayWording] = useState(translations.preview);


  React.useEffect(() => {
    if (resetPreview) {
      dispatch(actions.updatePreviewModes(true));
      setDisplayWording(translations.stopPreview);
      setResetPreview(false);
    }
  }, [resetPreview]);

  React.useEffect(() => {
    if (!previewMode) {
      setDisplayWording(translations.preview);
    } else {
      setDisplayWording(translations.stopPreview);
    }
  }, [previewMode]);

  const handleOnClick = () => {
    if (displayWording === translations.stopPreview) {
      dispatch(actions.updatePreviewModes(false));
    } else {
      dispatch(actions.updatePreviewModes(true));
    }
  };

  return (
    <Wrapper>
      <Button
        className='ack-btn'
        variant='contained'
        onClick={() => handleOnClick()}
      >
        {t(displayWording)}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  float: right;
  margin-right: 10px;

  .ack-btn {
    color: ${p => p.theme.buttonFont};
    background: ${p => p.theme.buttonColor};
    width: 110px;
    font-size: 12px;
    padding: 5px;
    height: 30px;
    line-height: 1;
  }
`;
